import { render, staticRenderFns } from "./RequestNewTest.vue?vue&type=template&id=6b6498ff&scoped=true"
import script from "./RequestNewTest.vue?vue&type=script&lang=js"
export * from "./RequestNewTest.vue?vue&type=script&lang=js"
import style0 from "./RequestNewTest.vue?vue&type=style&index=0&id=6b6498ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6498ff",
  null
  
)

export default component.exports